import styled from 'styled-components';

import { IconButton } from '@material-ui/core';
import { Menu } from 'antd';

import theme from '../../../styles/defaultTheme';

export const IconContainer = styled.div`
	cursor: pointer;
`;

export const InfoContract = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	margin-right: 10px;
    font-size: ${theme.font.size16};
    font-weight: bold;
    line-height: 21px;
`;

export const ContractContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	.active-contract {
		font-size: ${theme.font.size14};
		line-height: 17px;
  	}

	& li#contrato_-1 {
		border-bottom: 1px solid #CCC;
		font-size: ${theme.font.size16};
	}

	& li span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		font-size: ${theme.font.size14};
	}

	& span[class*="material-icons"] {
		width: fit-content;
	}

	@media screen and (max-width: 450px) {
		margin-top: 16px;
	}

	.section-title-contract-change {
		margin: 0;
		color: ${(props) => props.theme.black};
		font-size: ${theme.font.size16};
		font-weight: bold;
		line-height: 21px;
	}

	.section-title-contract, .active-contract {
		color: ${(props) => props.theme.grey} !important;
	}

	& li:hover{
	  background: ${(props) => props.theme.hoverOrangeTransparent};
	}

	.active-contract {
		font-size: ${theme.font.size14};
		line-height: 17px;
		text-align: end;
	}

`;

export const CustomItemGroup = styled(Menu.ItemGroup)`
  & {
    .ant-dropdown-menu-item-group-title {
      font-size: ${theme.font.size14};
      font-weight: bold;
      color: ${(props) => props.theme.black};
    }
    

    .ant-dropdown-menu-item {
      font-size: ${theme.font.size12};
      color: ${(props) => props.theme.greyLink};

    }
  }
`;

export const CustomIconButton = styled(IconButton)`
  &.MuiButtonBase-root {
    padding: 8px;
  }

  .MuiIcon-root {
    transition: all 0.2s ease-in;
    transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0)')};

    color: ${(props) => props.theme.orange};
  }
`;

export const CustomListContract = styled.div`
	cursor: pointer;
  color: ${(props) => props.theme.blackLink10};
`;

export const SituationLabelContainer = styled.div`
	min-width: 86px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	float: right;
	margin-top: ${theme.margin.x1};
	border: 1px solid ${({ contrastTheme, color }) => (contrastTheme ? '#FFFFFF' : `${color}`)};
	border-radius: 10px;
	background-color: ${({ contrastTheme, color }) => (contrastTheme ? '#000000' : `${color}10`)};

	font-size: ${theme.font.size12};
	font-weight: bold;
	line-height: 24px;
	color: ${({ contrastTheme, color }) => (contrastTheme ? '#FFFFFF' : color)};
`;
